import { ReactNode } from "react";
import { Dialog } from "primereact/dialog";

interface FormDialogProps {
  /** Dialog header title */
  header: string;
  /** Whether dialog is visible */
  visible: boolean;
  /** Callback when dialog is closed */
  onHide: () => void;
  /** Form content */
  children: ReactNode;
  /** Dialog width (default: '90vw') */
  width?: string;
  /** Maximum dialog width (default: '500px') */
  maxWidth?: string;
  /** Additional CSS class */
  className?: string;
}

/**
 * FormDialog provides consistent styling and sizing for form dialogs.
 */
export function FormDialog({
  header,
  visible,
  onHide,
  children,
  width = "90vw",
  maxWidth = "500px",
  className = "",
}: FormDialogProps) {
  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width, maxWidth }}
      onHide={onHide}
      className={className}
      headerClassName="border-bottom-1 surface-border pb-4"
      contentStyle={{ backgroundColor: "#ffffff", padding: "1rem" }}
    >
      <div className="flex flex-column gap-3">{children}</div>
    </Dialog>
  );
}
